(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info-display-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const button = event.target.closest('.product-form__add-button');

  if (!button) {
    return;
  }

  const form = button.closest('.product-form--display-product');
  const upload = form && form.querySelector('.p2p-native-artwork-upload__input');

  if (!upload || !upload.files.length) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  HTMLFormElement.prototype.submit.call(form);
}, true);
  } catch(e) { console.error(e); }
})();

})();
